import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  private leftButtonSource = new BehaviorSubject<FooterButton | undefined>(
    undefined,
  );
  private rightButtonSource = new BehaviorSubject<FooterButton | undefined>(
    undefined,
  );
  leftButton$: Observable<FooterButton | undefined> =
    this.leftButtonSource.asObservable();
  rightButton$: Observable<FooterButton | undefined> =
    this.rightButtonSource.asObservable();

  setLeftButton(button: FooterButton) {
    this.leftButtonSource.next(button);
  }

  setRightButton(button: FooterButton) {
    this.rightButtonSource.next(button);
  }

  disableLeftButton() {
    if (this.leftButtonSource.value !== undefined) {
      this.leftButtonSource.next({
        ...this.leftButtonSource.value,
        disabled: true,
      });
    }
  }

  enableLeftButton() {
    if (this.leftButtonSource.value !== undefined) {
      this.leftButtonSource.next({
        ...this.leftButtonSource.value,
        disabled: false,
      });
    }
  }

  disableRightButton() {
    if (this.rightButtonSource.value !== undefined) {
      this.rightButtonSource.next({
        ...this.rightButtonSource.value,
        disabled: true,
      });
    }
  }

  enableRightButton() {
    if (this.rightButtonSource.value !== undefined) {
      this.rightButtonSource.next({
        ...this.rightButtonSource.value,
        disabled: false,
      });
    }
  }

  clearLeftButton() {
    this.leftButtonSource.next(undefined);
  }

  clearRightButton() {
    this.rightButtonSource.next(undefined);
  }
}

export interface FooterButton {
  disabled?: boolean | Observable<boolean>;
  click: () => void | Promise<void>;
  label: string;
}
